export default __webpack_public_path__ + "static/media/fontMulish700_cyrillic_ext.56559df0.woff2";